import ConfirmTaxInfoModal from './ConfirmTaxInfoModalContainer';

export default ConfirmTaxInfoModal;
